import { ProviderBuilder, EGenMode } from '@educraft/base';
import { IColorSchemaSymbol } from './colorSchema';

// Color schemas
import { ColorSchemaBlack } from './colorSchemaBlack';
import { ColorSchemaBlue } from './colorSchemaBlue';
import { ColorSchemaGreen } from './colorSchemaGreen';
import { ColorSchemaPastel } from './colorSchemaPastel';
import { ColorSchemaYellow } from './colorSchemaYellow';
import { ColorSchemaPink } from './colorSchemaPink';
import { ColorSchemaSky } from './colorSchemaSky';
import { ColorSchemaNotebook } from './colorSchemaNotebook';
import { ColorSchemaFormal } from './colorSchemaFormal';

// Exercises
import { ExeEmpty } from './generators/empty';
import { ExeHeading } from './generators/heading';
import { ExeHeaderName } from './generators/headerName';
import { ExerciseEq } from './generators/exerciseEq';
import { ExerciseEqLarge } from './generators/exerciseEqLarge';
import { ExerciseEqBelow } from './generators/exerciseEqBelow';
import { ExerciseEqSign } from './generators/exerciseEqSign';
import { ExerciseCompare } from './generators/exerciseCompare';
import { ExerciseCompareAdv } from './generators/exerciseCompareAdv';
import { ExerciseAbc } from './generators/exerciseAbc';
import { ExerciseAbc0 } from './generators/exerciseAbc0';
import { ExerciseAbc1 } from './generators/exerciseAbc1';
import { ExerciseAbc2 } from './generators/exerciseAbc2';
import { ExerciseAbc3 } from './generators/exerciseAbc3';
import { ExerciseAbc4 } from './generators/exerciseAbc4';

export function registerExe(builder: ProviderBuilder): void {
  // Color schemas
  builder.add(IColorSchemaSymbol, ColorSchemaBlue, 'Blue');
  builder.add(IColorSchemaSymbol, ColorSchemaBlack, 'Black');
  builder.add(IColorSchemaSymbol, ColorSchemaPastel, 'Pastel');
  builder.add(IColorSchemaSymbol, ColorSchemaGreen, 'Green');
  builder.add(IColorSchemaSymbol, ColorSchemaYellow, 'Yellow');
  builder.add(IColorSchemaSymbol, ColorSchemaPink, 'Pink');
  builder.add(IColorSchemaSymbol, ColorSchemaSky, 'Sky');
  builder.add(IColorSchemaSymbol, ColorSchemaNotebook, 'Notebook');
  builder.add(IColorSchemaSymbol, ColorSchemaFormal, 'Formal');

  // Exercises (matching C# ExeServices registration order)
  builder.add(EGenMode.Exercise, ExeEmpty, 'Empty');
  builder.add(EGenMode.Exercise, ExerciseEq, 'ExerciseEq');
  builder.add(EGenMode.Exercise, ExerciseEqLarge, 'ExerciseEqLarge');
  builder.add(EGenMode.Exercise, ExerciseCompare, 'ExerciseCompare');
  builder.add(EGenMode.Exercise, ExerciseCompareAdv, 'ExerciseCompareAdv');
  builder.add(EGenMode.Exercise, ExeHeaderName, 'HeaderName');
  builder.add(EGenMode.Exercise, ExeHeading, 'Heading');
  builder.add(EGenMode.Exercise, ExerciseAbc, 'ExerciseAbc');
  builder.add(EGenMode.Exercise, ExerciseAbc0, 'ExerciseAbc0');
  builder.add(EGenMode.Exercise, ExerciseAbc1, 'ExerciseAbc1');
  builder.add(EGenMode.Exercise, ExerciseAbc2, 'ExerciseAbc2');
  builder.add(EGenMode.Exercise, ExerciseAbc3, 'ExerciseAbc3');
  builder.add(EGenMode.Exercise, ExerciseAbc4, 'ExerciseAbc4');
  builder.add(EGenMode.Exercise, ExerciseEqBelow, 'ExerciseEqBelow');
  builder.add(EGenMode.Exercise, ExerciseEqSign, 'ExerciseEqSign');
}
